export const BASE_TYPE = 'base';
export const BASE_SLOTS_PER_CITY = 50;
export const BASE_MAX_PER_USER = 3;
export const BASE_MATCHING_CITY_BONUS_PERCENT = 50;
export const BASE_OCCUPATION_HOURS = 24;
export const BASE_EXCLUDED_CITY_IDS = ['city_genesis'];

export const BASE_KEYS = {
  TAB_LABEL: 'base_tab_label',
  TITLE: 'base_title',
  SUBTITLE: 'base_subtitle',
  GLOBAL_SUMMARY: 'base_global_summary',
  OCCUPIED_SUMMARY: 'base_occupied_summary',
  OCCUPIED_COUNT: 'base_occupied_count',
  SLOT_AVAILABLE: 'base_slot_available',
  SLOT_OCCUPYING: 'base_slot_occupying',
  SLOT_FULL: 'base_slot_full',
  CLAIM: 'base_claim',
  CLAIMING: 'base_claiming',
  CLAIM_CONFIRM: 'base_claim_confirm',
  CLAIM_SUCCESS: 'base_claim_success',
  LOGIN_REQUIRED: 'base_login_required',
  ALREADY_OCCUPYING: 'base_already_occupying',
  MAX_REACHED: 'base_max_reached',
  FULL: 'base_full',
  ERROR: 'base_error',
  INSUFFICIENT_TICKETS: 'base_insufficient_tickets',
  BONUS_MATCH: 'base_bonus_match',
  BONUS_NONE: 'base_bonus_none',
  MY_BASE: 'base_my_base',
  MY_SECTION_TITLE: 'base_my_section_title',
  HOURS: 'base_hours',
  RATE: 'base_rate',
  TICKET_COST: 'base_ticket_cost',
  OCCUPANTS: 'base_occupants',
  SLOT_EMPTY: 'base_slot_empty',
  TIME_LEFT: 'base_time_left',
  BONUS_APPLIED: 'base_bonus_applied',
  REFRESH: 'base_refresh',
  CLOSE: 'base_close',
  DETAIL_TITLE: 'base_detail_title',
  MY_STATUS: 'base_my_status',
  MY_REMAINING: 'base_my_remaining',
  MY_EARNING: 'base_my_earning',
  MY_SLOT: 'base_my_slot',
  BONUS_CITY: 'base_bonus_city',
  BONUS_MATCHING: 'base_bonus_matching',
  BONUS_SNAPSHOT_NOTICE: 'base_bonus_snapshot_notice',
  RESERVE: 'base_reserve',
  RESERVE_CONFIRM: 'base_reserve_confirm',
  RESERVE_SUCCESS: 'base_reserve_success',
  RESERVE_CANCEL: 'base_reserve_cancel',
  RESERVE_CANCEL_SUCCESS: 'base_reserve_cancel_success',
  RESERVED_SLOT: 'base_reserved_slot',
  RESERVE_WAITING: 'base_reserve_waiting',
  NOT_GENESIS: 'base_error_not_genesis',
  RESERVE_GENESIS_HINT: 'base_reserve_genesis_hint',
  RANK_SPOT: 'base_rank_spot',
  RANK_MY_HOURLY: 'base_rank_my_hourly',
  ALREADY_RESERVED: 'base_error_already_reserved',
  CITY_RESERVE_FULL: 'base_error_city_reserve_full',
  USER_BANNED: 'base_error_banned'
};

/** BASE 도시 좌표 (equirectangular 투영용) */
export const BASE_CITY_COORDINATES = {
  city_seoul:     { lat: 37.57,  lng: 126.98 },
  city_newyork:   { lat: 40.71,  lng: -74.01 },
  city_berlin:    { lat: 52.52,  lng: 13.41  },
  city_hongkong:  { lat: 22.32,  lng: 114.17 },
  city_beijing:   { lat: 39.90,  lng: 116.41 },
  city_hanoi:     { lat: 21.03,  lng: 105.83 },
  city_paris:     { lat: 48.86,  lng: 2.35   },
  city_singapore: { lat: 1.35,   lng: 103.82 },
  city_taipei:    { lat: 25.03,  lng: 121.57 },
  city_capetown:  { lat: -33.92, lng: 18.42  },
};

export function isBaseCityConfig(item) {
  return !!item
    && typeof item.id === 'string'
    && !BASE_EXCLUDED_CITY_IDS.includes(item.id)
    && item.baseEnabled !== false;
}

export function deriveBaseCitiesFromCityConfig(configList) {
  if (!Array.isArray(configList)) return [];
  return configList.filter(isBaseCityConfig);
}

function millisOf(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value.seconds != null) return value.seconds * 1000;
  if (value._seconds != null) return value._seconds * 1000;
  if (typeof value === 'number') return value;
  return 0;
}

/** 현재 점유 슬롯의 예상 SPOT. 만료 시각과 최대 점유 시간에서 멈춘다. */
export function estimateOccupiedSpot(status, config, nowMs = Date.now()) {
  const captured = millisOf(status?.capturedAt);
  if (!captured) return 0;
  const rate = Number(status?.rateSnapshot ?? config?.rate) || 0;
  const limitHours = Number(status?.limitHoursSnapshot ?? config?.limitHours) || BASE_OCCUPATION_HOURS;
  const expires = millisOf(status?.expiresAt);
  const capMs = captured + limitHours * 60 * 60 * 1000;
  const end = Math.min(nowMs, expires > 0 ? expires : capMs, capMs);
  const elapsedMin = Math.min(limitHours * 60, Math.max(0, (end - captured) / 60000));
  const multiplier = Number(status?.cityOwnedBonusMultiplier) || 1;
  return Math.round(elapsedMin * rate * multiplier * 10000) / 10000;
}

/** 아직 점유 중인 슬롯의 시간당 SPOT. 만료된 자리는 0이다. */
export function estimateHourlySpot(status, config, nowMs = Date.now()) {
  const captured = millisOf(status?.capturedAt);
  if (!captured) return 0;
  const rate = Number(status?.rateSnapshot ?? config?.rate) || 0;
  const limitHours = Number(status?.limitHoursSnapshot ?? config?.limitHours) || BASE_OCCUPATION_HOURS;
  const expires = millisOf(status?.expiresAt);
  const capMs = captured + limitHours * 60 * 60 * 1000;
  const end = Math.min(expires > 0 ? expires : capMs, capMs);
  if (nowMs >= end) return 0;
  const multiplier = Number(status?.cityOwnedBonusMultiplier) || 1;
  return Math.round(rate * 60 * multiplier * 10000) / 10000;
}
